import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-map-live-status-loader',
  templateUrl: './map-live-status-loader.component.html',
  styleUrls: ['./map-live-status-loader.component.scss']
})
export class MapLiveStatusLoaderComponent implements OnInit {

  @Input() geoJsonObject;
  @Input() lat;
  @Input() lng;
  @Input() markers;

  @Output() mapMarkerClick: EventEmitter<any>;
  @Output() MouseOver: EventEmitter<any>;
  @Output() MouseOut: EventEmitter<any>;

  constructor() {
    this.mapMarkerClick = new EventEmitter();
    this.MouseOver = new EventEmitter();
    this.MouseOut = new EventEmitter();
  }

  ngOnInit() {
    // console.log(this.geoJsonObject);
  }

  styleFunc(feature) {
    return ({
      clickable: false,
      fillColor: '#50a3ea', // feature.getProperty('color'),
      strokeWeight: 1,
      stroke: '#50a3ea'
    });
  }

  onMarkerClick(event) {
    this.mapMarkerClick.emit(event);
  }

  onMouseOver(event) {
    this.MouseOver.emit(event);
  }

  onMouseOut(event) {
    this.MouseOut.emit(event);
  }

}
